import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Input, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { Chart } from 'angular-highcharts';

import { KlaHttpService } from '../../shared/tools/services/kla.http.service';
import { HighchartComponent } from '../highchart/highchart.component';
import { TitleComponent } from 'app/shared/tools/title/title.component';
import { SafeHtmlPipe } from 'app/shared/tools/safe-html/safe-html';
import { InViewDirective } from 'app/directives/in-view.directive';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';
import { HighchartsService } from 'app/shared/tools/services/kla.highcharts.service';

@Component({
  selector: 'kla-left-highcharts',
  templateUrl: './left-highcharts.component.html',
  styleUrls: ['./left-highcharts.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    '(window:resize)': 'onResize($event)'
  },
  standalone: true,
  imports: [ CommonModule, HighchartComponent, TitleComponent, SafeHtmlPipe, InViewDirective, DynamicContentComponent ]
})
export class LeftHighchartsComponent implements OnInit {

  @ViewChild('panel', {static: true})
  public panel: ElementRef;

  @Input() config: any;
  @Input() lineConfig: any;
  @Input() chartId: any;
  chartType: any;
  chartData: any;
  configHighchart: Chart;
  hasLoaded: boolean = false;

  constructor(
    private http: KlaHttpService,
    @Inject(PLATFORM_ID) private platformId,
    private highchartsService: HighchartsService
  ) { }

  ngOnInit() {
  }

  onAppear(event) {
    if(event && !this.hasLoaded) {
      this.loadData();
      this.hasLoaded = true;
    }
  }

  loadData() {
    this.chartType = JSON.parse(this.config.chartId)?.type;
    if(isPlatformBrowser(this.platformId)) {
      this.http.getHighchartData(this.chartId).subscribe(data => {
        this.chartData = data;
        if (!data.chart.width) {
          data.chart.width = this.panel.nativeElement.offsetWidth < 450 ? 400 : this.panel.nativeElement.offsetWidth;
        }

        if (
          typeof (data.plotOptions) != 'undefined' &&
          typeof (data.plotOptions.area) != 'undefined' &&
          typeof (data.plotOptions.area.events) != 'undefined' &&
          typeof (data.plotOptions.area.events.legendItemClick) != 'undefined'
        ) {
          delete data.plotOptions.area.events.legendItemClick;
          data.legend = data.legend || {};
          data.legend.events = data.legend.events || {};
          data.legend.events.itemClick = function (event) {
            if (event.legendItem.type !== 'area') {
              return;
            }

            let thisSeries = event.legendItem,
              lastSeries = thisSeries.chart.series[thisSeries.chart.series.length - 1],
              newData = [];

            if (thisSeries === lastSeries) {
              return false;
            }

            if (thisSeries !== lastSeries) {
              if (thisSeries.visible) {
                thisSeries.getColumn('y').forEach(function (yVal, index) {
                  newData.push(lastSeries.getColumn('y')[index] + yVal);
                });
              } else {
                thisSeries.getColumn('y').forEach(function (yVal, index) {
                  newData.push(lastSeries.getColumn('y')[index] - yVal);
                });
              }

              lastSeries.setData(newData);
            }
          };
        }

        if (this.panel.nativeElement.offsetWidth < 760 && this.isChartPie(this.chartData)) {
          data.plotOptions.pie.innerSize = this.percentage(this.panel.nativeElement.offsetWidth, 760);
        }

        if(this.chartData.chart.type === 'solidgauge' && ('maxSize' in data.plotOptions.solidgauge)) {
          if(window.innerWidth < 769) {
            data.plotOptions.solidgauge.maxSize = '50%'
          }
          if(window.innerWidth < 1200) {
            data.plotOptions.solidgauge.maxSize = '60%'
          }
        }

        this.configHighchart = new Chart(data);

      });

    }
  }

  private percentage(first, second) {
    return first / second * 100;
  }

  onResize(event) {
    if(this.chartData) {
      this.configHighchart.destroy;
      this.chartData.chart.width = this.panel.nativeElement.offsetWidth < 450 ? 400 : this.panel.nativeElement.offsetWidth;
      if (this.panel.nativeElement.offsetWidth < 760 && this.isChartPie(this.chartData)) {
        this.chartData.plotOptions.pie.innerSize = this.percentage(this.panel.nativeElement.offsetWidth, 760);
      }
      this.configHighchart = new Chart(this.chartData);
    }
  }

  isChartPie(data: any) {
    return data.chart.type == 'pie'
    && typeof (data.plotOptions) != 'undefined'
    && typeof (data.plotOptions.pie) != 'undefined';
  }
}
